// GrnAdd.jsx
import React, { useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import GRNForm from "./GRNForm";
import AssetStepperForm from "./AssestStepperForm";
import AssetCardList from "./AssetCardList";
import { VscSaveAs } from "react-icons/vsc";
import PreviewModal from "./PreviewModal";
import { useMemo } from "react";
import { creategrnApi } from "../../../services/GrnService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const assetKeyMap = {
  assetName: "name",
  catagory: "category",
  sub_catagory: "sub_category",
  other_info: "unit_other_details",
  purchaseCost: "purchase_cost",
  purchaseDate: "purchase_date",
  assetId: "manual_asset_id",
  image: "asset_unit_image",
  warrantyEnd: "warranty_end_date",
  insuranceProvider: "insurance_provider",
  policyNumber: "policy_number",
  insuranceExpiry: "insurance_expiry",
  lifespan: "expected_lifespan_months",
  scrapValue: "scrap_value",
  depreciation_method: "depreciation_method",
  depreciationRate: "depreciation_rate",
  serviceCycle: "service_cycle_months",
  manufacturer: "manufacturer",
  brand: "brand",
  modelNumber: "model_number",
  serialNumber: "serial_number",
  warrantyFile: "warranty_file",
  insuranceFile: "insurance_file",
};

const grnKeyMap = {
  grnNumber: "grn_number",
  receivedDate: "received_date",
  vendor: "vendor_id",
  invoiceNumber: "invoice_number",
  remarks: "remarks",
  invoiceAttachment: "invoice_attachment",
};

const GrnAdd = () => {
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [assets, setAssets] = useState([]);
  const [formMode, setFormMode] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [copyIndex, setCopyIndex] = useState(null);
  const [actualEditingIndex, setActualEditingIndex] = useState(null);

  const [grnAddLoading, setGrnAddLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const initialAssetValues = useMemo(() => {
    if (formMode === "edit" && editingIndex !== null) {
      return assets[editingIndex] || {};
    }

    if (formMode === "copy" && copyIndex !== null) {
      const original = assets[copyIndex] || {};
      const copied = {};

      const copyExcludeFields = [
        "insuranceFile",
        "image",
        "warrantyFile",
        "serialNumber",
        "modelNumber",
      ];

      for (const key in original) {
        if (!copyExcludeFields.includes(key)) {
          copied[key] = original[key];
        }
      }

      return copied;
    }

    return {};
  }, [formMode, editingIndex, copyIndex, assets]);

  const [grnForm, setGrnForm] = useState({
    grnNumber: "",
    receivedDate: "",
    vendor: "",
    invoiceNumber: "",
    remarks: "",
    invoiceAttachment: null,
  });
  const handleEditIcon = (index) => {
    setFormMode("edit");
    setEditingIndex(index);
    setActualEditingIndex(index);
    setCopyIndex(null);
  };

  const handleCopyIcon = (index) => {
    setFormMode("copy");
    setCopyIndex(index);
    setEditingIndex(null);
    toast.success("Coppied successfully");
  };

  const handleResetFormMode = () => {
    setFormMode(null);
    setEditingIndex(null);
    setCopyIndex(null);
    setActualEditingIndex(null);
  };

  const handleResetGrn = () => {
    setGrnForm({
      grnNumber: "GRN-2025-001",
      receivedDate: "",
      vendor: "",
      invoiceNumber: "",
      remarks: "",
      invoiceAttachment: null,
    });
    setAssets([]);
    setEditingIndex(null);
    setErrors({});
  };
  const handleGRNChange = (updatedForm) => {
    setGrnForm(updatedForm);
    if (updatedForm?.receivedDate) {
      setErrors((prevErrors) => ({ ...prevErrors, receivedDate: false }));
    }
    if(updatedForm?.invoiceNumber) {
      setErrors((prevErrors) => ({ ...prevErrors, invoiceNumber: false }));
    }
    if(updatedForm?.invoiceAttachment) {
      setErrors((prevErrors) => ({ ...prevErrors, invoiceAttachment: false }));
    }
  };
  const validateGRN = () => {
    const newErrors = {};
    if (!grnForm.receivedDate) {
      newErrors.receivedDate = "Received Date is required";
    }
    if (!grnForm.invoiceNumber) {
      newErrors.invoiceNumber = "Inv number is required";
    }
    if (!grnForm.invoiceAttachment) {
      newErrors.invoiceAttachment = "Attachment is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveAsset = (assetData) => {
    if (actualEditingIndex !== null) {
      const updated = [...assets];
      updated[actualEditingIndex] = assetData;
      setAssets(updated);
    } else {
      setAssets([...assets, assetData]);
    }

    handleResetFormMode();
  };

  const handleDeleteAsset = (assetindex) => {
    const updated = assets.filter((a, i) => i != assetindex);
    setAssets(updated);
    setEditingIndex(null);
  };

  const handleSubmit = () => {
    if (!validateGRN()) return;

    const formData = new FormData();
    for (const key in grnForm) {
      let value;
      const mappedKey = grnKeyMap[key];
      if (key === "vendor") {
        value = grnForm[key]?.value || "";
      } else {
        value = grnForm[key];
      }

      if (mappedKey && value !== null && value !== undefined) {
        formData.append(mappedKey, value);
      }
    }

    const asset_unit_list = [];
    assets.forEach((asset, index) => {
      const asset_unit_obj = {};
      for (const key in asset) {
        let value;
        const mappedKey = assetKeyMap[key];
        if (key === "catagory") {
          value = asset[key]?.value || "";
        } else if (key === "sub_catagory") {
          value = asset[key]?.value || "";
        } else {
          value = asset[key];
        }
        if (!mappedKey) continue;

        if (value instanceof File) {
          formData.append(`${mappedKey}_${index}`, value);
        } else if (value !== null && value !== undefined) {
          asset_unit_obj[mappedKey] = value;
        }
      }
      asset_unit_list.push(asset_unit_obj);
    });
    formData.append("asset_unit_list", JSON.stringify(asset_unit_list));

    setGrnAddLoading(true);
    creategrnApi(formData)
      .then((res) => {
        toast.success("Grn created successfully");
        handleResetGrn();
        navigate("/grn");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later",
        );
      })
      .finally(() => {
        setGrnAddLoading(false);
      });
  };

  return (
    <Container fluid>
      <GRNForm form={grnForm} errors={errors} onChange={handleGRNChange} />
      <Row>
        <Col md={8}>
          <AssetStepperForm
            isEditMode={actualEditingIndex !== null}
            onSubmit={handleSaveAsset}
            onCancel={handleResetFormMode}
            initialValues={initialAssetValues}
          />
        </Col>
        <Col md={4}>
          <AssetCardList
            assets={assets}
            onEdit={handleEditIcon}
            onCopy={handleCopyIcon}
            onDelete={handleDeleteAsset}
            setShowPreview={setShowPreview}
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-4">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={assets?.length === 0 || grnAddLoading}
        >
          {grnAddLoading && <Spinner animation="border" size="sm" />}
          <VscSaveAs className="me-1" size={18} /> Submit GRN
        </button>
      </div>
      <PreviewModal
        show={showPreview}
        onClose={() => setShowPreview(false)}
        asset={assets}
        grn={grnForm}
      />
    </Container>
  );
};

export default GrnAdd;
